import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

const translations: Localizations = {
  'en-US': {
    'offers.allDays': 'All days',
    'offers.allCategories': 'All categories',
    'offers.allOffers': 'All offers',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Close',
    'offers.seeWholeOffer': 'See whole offer',
    'offers.noOffers': 'Unfortunately no offers are currently available',
    'offers.noSearchResults': 'No results found for your search',
    'offers.noContent':'No content currently available',
    'offers.searchBox':'Search',
    'offers.clearSelection': 'Clear selection',
    'offers.openInfo':'Open offer description',
    'offers.daysLowestPrice': '30 day lowest price',
    'offers.store': 'Store',
    'offers.offer': 'Offer',
    'offers.send-email': 'Send email',
    'offers.valid': 'Valid',
    'offers.selectedDays': '{count} days selected',
    'offers.selectedCategories': '{count} categories selected',
    'search.noResults': 'No results',
    'search.placeholder': 'Search',
    'campaign.all-program': 'Show all programs',
    'campaign.all-days': 'All days',
    'campaign.all-categories': 'All categories',
    'store.status.CLOSED': 'Closed',
    'store.status.BY_APPOINTMENT': 'By appointment',
    'store.status.OPEN': 'Open',
    'store.status.TEMPORARY_CLOSED': 'Temporarily closed',
  },
  'fi-FI': {
    'offers.allDays': 'Kaikki päivät',
    'offers.allCategories': 'Kaikki toimialat',
    'offers.allOffers': 'Kaikki tarjoukset',
    'offers.showWishList': 'Näytä muistilista',
    'offers.closeOffer': 'Sulje',
    'offers.seeWholeOffer': 'Avaa koko tarjous',
    'offers.noOffers': 'Etuja ei valitettavasti tällä hetkellä ole saatavilla',
    'offers.noSearchResults': 'Hakutuloksia ei löytynyt',
    'offers.noContent':'Ei näytettävää sisältöä juuri nyt',
    'offers.searchBox':'Haku',
    'offers.clearSelection': 'Tyhjennä valinnat',
    'offers.openInfo':'Avaa lisätiedot',
    'offers.daysLowestPrice': '30 pv alin hinta',
    'offers.store': 'Liike',
    'offers.offer': 'Tarjous',
    'offers.send-email': 'Lähetä sähköposti',
    'offers.valid': 'Voimassa',
    'offers.selectedDays': '{count} päivää valittu',
    'offers.selectedCategories': '{count} toimialaa valittu',
    'search.noResults': 'Ei tuloksia',
    'search.placeholder': 'Hae',
    'campaign.all-program': 'Koko ohjelma',
    'campaign.all-days': 'Kaikki päivät',
    'campaign.all-categories': 'Kaikki toimialat',
    'store.status.CLOSED': 'Suljettu',
    'store.status.BY_APPOINTMENT': 'Sopimuksen mukaan',
    'store.status.OPEN': 'Avoinna',
    'store.status.TEMPORARY_CLOSED': 'Tilapäisesti suljettu',
  },
  'sv-SE': {
    'offers.allDays': 'Alla dagar',
    'offers.allCategories': 'Alla kategorier',
    'offers.allOffers': 'Alla erbjudanden',
    'offers.showWishList': 'Visa önskelista',
    'offers.closeOffer': 'Stäng',
    'offers.seeWholeOffer': 'See hela förmånen',
    'offers.noOffers': 'Tyvärr finns det för tillfället inga förmåner',
    'offers.noSearchResults': 'Inga resultat hittades för din sökning',
    'offers.noContent':'Inget innehåll tillgängligt för tillfället',
    'offers.searchBox':'Söka',
    'offers.clearSelection': 'Rensa val',
    'offers.openInfo':'Öppna erbjudandets info',
    'offers.daysLowestPrice': 'Lägsta pris 30 dagar',
    'offers.store': 'Butiker',
    'offers.offer': 'Erbjudanden',
    'offers.send-email': 'Skicka e-post',
    'offers.valid': 'Gäller',
    'offers.selectedDays': '{count} dagar valda',
    'offers.selectedCategories': '{count} kategorier valda',
    'search.noResults': 'Inga resultat',
    'search.placeholder': 'Sök',
    'campaign.all-program': 'Visa alla program',
    'campaign.all-days': 'Alla dagar',
    'campaign.all-categories': 'Alla kategorier',
    'store.status.CLOSED': 'Stängt',
    'store.status.BY_APPOINTMENT': 'Efter överenskommelse',
    'store.status.OPEN': 'Öppen',
    'store.status.TEMPORARY_CLOSED': 'Tillfälligt stängt',
  },
  'nb-NO': {
    'offers.allDays': 'Alle dager',
    'offers.allCategories': 'Alle kategorier',
    'offers.allOffers': 'Alle tilbud',
    'offers.showWishList': 'Se ønskeliste',
    'offers.closeOffer': 'Lukk',
    'offers.seeWholeOffer': 'Se hele fordelen',
    'offers.noOffers': 'Dessverre ingen fordeler tilgjengelig for øyeblikket',
    'offers.noSearchResults': 'Ingen resultater funnet for søket ditt',
    'offers.noContent':'Inget innhold tilgjengelig for øyeblikket',
    'offers.searchBox':'Søk',
    'offers.clearSelection': 'Fjern valg',
    'offers.openInfo':'Les mer',
    'offers.daysLowestPrice': 'Laveste pris siste 30 dager',
    'offers.store': 'Butikker',
    'offers.offer': 'Tilbud',
    'offers.send-email': 'Send e-post',
    'offers.valid': 'Gyldig',
    'offers.selectedDays': '{count} dager valgt',
    'offers.selectedCategories': '{count} kategorier valgt',
    'search.noResults': 'Ingen resultater',
    'search.placeholder': 'Søk',
    'campaign.all-program': 'Vis alle program',
    'campaign.all-days': 'Alle dager',
    'campaign.all-categories': 'Alle kategorier',
    'store.status.CLOSED': 'Stängt',
    'store.status.BY_APPOINTMENT': 'Etter avtale',
    'store.status.OPEN': 'Åpen',
    'store.status.TEMPORARY_CLOSED': 'Midlertidig stengt',
  },
  'et-EE': {
    'offers.allDays': 'Kõik päevad',
    'offers.allCategories': 'Kõik kategooriad',
    'offers.allOffers': 'Kõik pakkumised',
    'offers.showWishList': 'Vaata soovinimekirja',
    'offers.closeOffer': 'Sulge',
    'offers.seeWholeOffer': 'Vaata kogu soodustust',
    'offers.noOffers': 'Kahjuks hetkel soodustusi ei ole',
    'offers.noSearchResults': 'Teie otsingule ei leitud tulemusi',
    'offers.noContent':'Hetkel sisu puudub',
    'offers.searchBox':'Otsi',
    'offers.clearSelection': 'Tühjenda valik',
    'offers.openInfo':'Ava pakkumise kirjeldus',
    'offers.daysLowestPrice': 'Viimase 30 päeva madalaim hind',
    'offers.store': 'Kauplused',
    'offers.offer': 'Pakkumised',
    'offers.send-email': 'Saada e-post',
    'offers.valid': 'Kehtib kuni',
    'offers.selectedDays': '{count} päeva valitud',
    'offers.selectedCategories': '{count} kategooriat valitud',
    'search.noResults': 'Vasted puuduvad',
    'search.placeholder': 'Otsi',
    'campaign.all-program': 'Kõik programmid',
    'campaign.all-days': 'Kõik päevad',
    'campaign.all-categories': 'Kõik kategooriad',
    'store.status.CLOSED': 'Suletud',
    'store.status.BY_APPOINTMENT': 'Tööaja kokkuleppel',
    'store.status.OPEN': 'Avatud',
    'store.status.TEMPORARY_CLOSED': 'Ajutiselt suletud',
  },
  'da-DK': {
    'offers.allDays': 'Alle dage',
    'offers.allCategories': 'Alle kategorier',
    'offers.allOffers': 'Alle fordele',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Luk',
    'offers.seeWholeOffer': 'Se hele fordelen',
    'offers.noOffers': 'Der er desværre ingen fordele i øjeblikket',
    'offers.noSearchResults': 'Ingen resultater fundet for din søgning',
    'offers.noContent':'Intet indhold tilgængeligt i øjeblikket',
    'offers.searchBox':'Søge',
    'offers.clearSelection': 'Ryd markering',
    'offers.openInfo':'Åbn tilbudsbeskrivelse',
    'offers.daysLowestPrice': 'Laveste pris de sidste 30 dage',
    'offers.store': 'Butikker',
    'offers.offer': 'Tilbud',
    'offers.send-email': 'Send e-mail',
    'offers.valid': 'Gyldig',
    'offers.selectedDays': '{count} dage valgt',
    'offers.selectedCategories': '{count} kategorier valgt',
    'search.noResults': 'Ingen resultater',
    'search.placeholder': 'Søg',
    'campaign.all-program': 'Vis alle program',
    'campaign.all-days': 'Alle dage',
    'campaign.all-categories': 'Alle kategorier',
    'store.status.CLOSED': 'Lukket',
    'store.status.BY_APPOINTMENT': 'Efter aftale',
    'store.status.OPEN': 'Åben',
    'store.status.TEMPORARY_CLOSED': 'Midlertidigt lukket',
  },
};

const provider: LocalizationsProvider = {
  namespace: theme_ns,
  localizations: translations,
};

export default provider;


